import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../LoginPage/Login.css';
import loginimg from '../img/img.jpg';
import LogoCM from '../img/LogoCM.png';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from '../config';
import Loader from '../Utils/AnLoader/Loader'
import 'bootstrap-icons/font/bootstrap-icons.css';
import Swal from 'sweetalert2';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      showPassword: false, // added state for toggling password visibility,
      loading: false,
      data: null,
      showPassword: false, // This line might be redundant
    };
    this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
  }

  componentDidMount() {
    localStorage.removeItem("SelectedValue")
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ loading: true });

    fetch(API_URL + '/api/login/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username: this.state.email,
        password: this.state.password
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.message === 'Login successful') {
          localStorage.setItem('token', data.token);
          localStorage.setItem('role', data.role);
          toast.success("Login successful!");
          setTimeout(() => {
            sessionStorage.setItem('UserName', data.username);
            window.location.href = '/PoDetails';
          }, 1000);
        } else {
          toast.error("Invalid Credential !");
        }
      })
      .catch(error => {
        console.error('Error:', error);
        toast.error("An error occurred. Please try again.");
      })
  }

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword
    }));
  };

  downloadZip = () => {
    const zipUrl = 'Charu-Merchandising.zip';

    const downloadAnchor = document.createElement('a');
    downloadAnchor.href = zipUrl;
    downloadAnchor.download = 'Charu-Merchandising.zip';

    document.body.appendChild(downloadAnchor);
    downloadAnchor.click();
    document.body.removeChild(downloadAnchor); 
  }

  render() {
    return (
      <div>
        <section className="vh-40" style={{ width: "100%" }}>
          <div className="top-bar"></div>
          <nav className="navbar navbar-light bg-light row m-0 p-0">
            <div className='col-md-6 col-6'>
              <a className="navbar-brand" href="#">
                <div className="d-flex align-items-center" >
                  <img src={LogoCM} width="220" height="50" className="d-inline-block align-top" alt="" style={{ marginLeft: "20px" }} />
                </div>
              </a>
            </div>
            <div className='col-md-6 col-6 text-end'style={{marginTop:"-20px"}}>
              <button type='button' className='btn' style={{background:"darkgray"}} onClick={this.downloadZip}>
              <i className="bi bi-download" style={{ fontSize: '20px', cursor: 'pointer',color:"#055032" }} ></i>
              </button>
            </div>
          </nav>
          <div className="container h-100">
            <div className="media_css row align-items-center justify-content-center h-100" style={{ marginTop: "10px", backgroundColor: "#f9fbfd", width: "100%", marginLeft: "93px" }}>
              <div className="col-md-5 col-lg-5 col-xl-5">
                <img src={loginimg} style={{ marginLeft: "-101px", width: "100%" }} className=" media_css_img img-fluid" alt="laptop" height="100" />
              </div>
              <div className="col-md-5 col-lg-5 col-xl-5 mt-4">
                <div className="login-header" style={{ marginBottom: "55px" }}>
                  <h2>Log in to Charu Merchandising</h2>
                  <h6 style={{ marginTop: "18px" }}>Enter your details below</h6>
                </div>
                <form onSubmit={this.handleSubmit}>
                  <div className="col-md-10 mb-3">
                    <input
                      type="email"
                      placeholder='Enter your username'
                      id="floatingInput"
                      name="email"
                      className="form-control"
                      value={this.state.email}
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div className="col-md-10 mb-3">
                    <div className="input-group">
                      <input
                        type={this.state.showPassword ? 'text' : 'password'}
                        id="floatingPassword"
                        placeholder="Enter your password"
                        className="form-control"
                        name="password"
                        value={this.state.password}
                        onChange={this.handleInputChange}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={this.togglePasswordVisibility}
                      >
                        {this.state.showPassword ? (
                          <i className="bi bi-eye-slash-fill"></i>
                        ) : (
                          <i className="bi bi-eye-fill"></i>
                        )}
                      </button>
                    </div>
                  </div>
                  <div className="col-md-10 mb-3">
                    <button type="submit" style={{ width: '100%', color: 'white' }} className="btn-sm buttonBorder1G">
                      Log In
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <ToastContainer />
        </section>
      </div>
    );
  }
}

export default Login;
